export const SET_LANGUAGES_ACTION = 'SYSTEM.SET_LANGUAGES_ACTION';

export const GET_LANGUAGES_TRANSACTION = 'SYSTEM.GET_LANGUAGES_TRANSACTION';
